import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import AggregatedCustomer from "./AggregatedCustomer";
import { useUserData } from "../../../../context/UserDataContext";
import AggregatedRemainCustomer from "./AggregatedRemainCustomer";

const headersList = [
  { colName: "show_name", name: "مشتری" },
  { colName: "total", name: "وزن" },
  { colName: "total_one", name: "ج۱" },
  { colName: "total_two", name: "ج۲" },
  { colName: "total_three", name: "ج۳" },
  { colName: "total_four", name: "ج۴" },
  { colName: "total_five", name: "ج۵" },
  { colName: "total_six", name: "ج۶" },
  { colName: "delivery", name: "جزییات" },
];
const dataKey = [
  "name",
  "total",
  "object.total_bangle_nums.size_one_num",
  "object.total_bangle_nums.size_two_num",
  "object.total_bangle_nums.size_three_num",
  "object.total_bangle_nums.size_four_num",
  "object.total_bangle_nums.size_five_num",
  "object.total_bangle_nums.size_six_num",
];

const mobileHeadersList = [
  { colName: "name", name: "مشتری" },
  { colName: "total", name: "وزن" },
];

const TabFour = (props) => {
  const { userData } = useUserData();
  const [storeFilter, setStoreFilter] = useState(null);
  const [cityFilter, setCityFilter] = useState(null);
  useState(null);

  const [weightSum, setWeightSum] = useState(0);
  const [weightSumRed, setWeightSumRed] = useState(0);
  const [weightSumGreen, setWeightSumGreen] = useState(0);
  const [isFilterOn, setIsFilterOn] = useState(false);

  const [citiesList, setCitiesList] = useState({ results: [] });
  const [cityPaginationPageInfo, setCityPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const getCitiesApi = useFetch({
    method: "get",
    url: "City_Service",
    trigger: true,
    pagination: cityPaginationPageInfo,
    setter: setCitiesList,
    argFunc: (res) => {
      setCityPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const filterList = [
    {
      type: "textField",
      label_fa: "نام مشتری",
      label_en: "storeName",
      state: storeFilter,
    },

    {
      type: "select",
      label_fa: "شهر",
      label_en: "city",
      state: cityFilter,
      menuItems: citiesList.results,
      fromApi: true,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 1000,
    count: 0,
  });
  const rowsWeightSum = (res) => {
    let sum = 0;
    let sum_red = 0;
    let sum_green = 0;
    for (let index = 0; index < res.length; index++) {
      sum = sum + parseFloat(res[index].total);
      sum_red = sum_red + parseFloat(res[index].total_red);
      sum_green = sum_green + parseFloat(res[index].total_green);
    }
    setWeightSum(sum);
    setWeightSumRed(sum_red);
    setWeightSumGreen(sum_green);
  };
  const [ringsList, setRingsList] = useState([]);
  const getUserBanglesSumApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_report_customer_order_items`,
    // pagination: paginationPageInfo,
    params: {
      store_name: storeFilter,
      city:
        cityFilter !== "all"
          ? cityFilter !== null && cityFilter !== "all"
            ? citiesList.results.filter((it) => it.id == cityFilter)[0].name
            : cityFilter
          : undefined,
    },
    trigger: true,
    setter: setRingsList,
    argFunc: (res) => {
      // setPaginationPageInfo({
      //   current: res.current,
      //   pageSize: res.pageSize,
      //   count: res.count,
      //   next: res.next,
      //   previous: res.previous,
      // });
      // rowsWeightSum(res.results);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
    if (state == "city") setCityFilter(e);
  };
  const filter = () => {
    if (storeFilter !== null || cityFilter !== null) {
      setIsFilterOn(true);
      setRingsList({ results: [] });

      getUserBanglesSumApi.reFetch();
    }
  };
  const reset_filter = () => {
    setStoreFilter(null);
    setCityFilter(null);
    setRingsList({ results: [] });

    getUserBanglesSumApi.reFetch();
  };
  const actionsList = [];
  const buttonsList = [
    {
      label: "جزييات سفارش",
      component: (it) => (
        <AggregatedRemainCustomer
          RemoveOrder
          selectedRow={it}
          getUserBanglesSumApi={getUserBanglesSumApi}
        />
      ),
    },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setRingsList({ results: [] });
    getUserBanglesSumApi.reFetch();
  };

  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <>
        <PanelTable
          header="لیست سفارش‌های جاری براساس مشتری (کسری):"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={ringsList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AccountBalanceIcon />}
        />

        <MuiPagination
          onChange={onChangePage}
          count={Math.ceil(
            paginationPageInfo.count / paginationPageInfo.pageSize
          )}
        />
      </>
    </>
  );
};

export default TabFour;
